import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import FetchHelper from '../../helpers/fetch_helper';
import Actions from '../../actions/actions';
import { useSelector } from 'react-redux';
import FinancingHelper from '../../helpers/financing_helper';

const FinancingMethodSelector = ({ proposal, customer, callback, optionalEligibility, enablePastFrid = false }) => {
  const [productType, setProductType] = useState('');
  const updateFinancingMethod = useSelector((redux) => redux?.locks?.updateFinancingMethod);
  // Find the primary financing method and set it as selected on component mount
  useEffect(() => {
    if (proposal?.financingMethods?.length > 0) {
      const primaryMethod = proposal.financingMethods.find((fm) => fm.primary);
      if (primaryMethod?.productType) {
        setProductType(primaryMethod.productType);
      }
    }
  }, [proposal]);

  // Handle selection change
  const handleChange = (event) => {
    const newProductType = event.target.value;
    setProductType(newProductType); // Update local state immediately for responsiveness

    // Actions.requestModals({
    //   title: `Switching your project type!`,
    //   contents: (
    //     <div style={{ minWidth: '590px' }}>
    //       <PageSpinner />
    //     </div>
    //   ),
    //   cancelButtonText: false,
    //   okButtonText: false,
    //   modalID: 'qa-project-toggle-modal',
    // });

    Actions.acquireLock('updateFinancingMethod');

    if (typeof callback !== 'function') {
      FetchHelper.fetchJson(`customers/${customer?.id}/financing-methods/${newProductType}/primary`, {
        method: 'PATCH',
        version: '/v3',
      }).then(() => window.location.reload());
    } else {
      (async () => {
        await callback(newProductType);
        Actions.releaseLock('updateFinancingMethod');
      })();
    }
  };

  let financingMethods = proposal?.financingMethods?.sort?.((a, b) => {
    if (a.productType === 'loan' && b.productType !== 'loan') return -1;
    if (a.productType !== 'loan' && b.productType === 'loan') return 1;
    return a.productType.localeCompare(b.productType); // fallback predictable sort
  });

  if (optionalEligibility) {
    financingMethods = financingMethods.filter(({ productSku }) => {
      return FinancingHelper.rateCardsByProduct(optionalEligibility)[productSku]?.length;
    });
  }

  // Check if we should disable the dropdown
  const isDisabled =
    customer.status !== 'New' ||
    !proposal ||
    (financingMethods?.length || 0) < 2 ||
    (!enablePastFrid && !!proposal?.financingRequestId) ||
    !!updateFinancingMethod;

  // Don't render anything if there are no financing methods
  if (!financingMethods?.length) {
    return null;
  }

  return (
    <div className="proposal-product-type-selector" style={{}}>
      <TextField
        id="product-type-select"
        name="product-type-select"
        SelectProps={{
          native: true,
        }}
        onChange={handleChange}
        value={productType || ''}
        label="Project Type"
        select
        InputLabelProps={{ shrink: true }}
        disabled={isDisabled}
        size="small"
        margin="dense"
        style={{ backgroundColor: 'white' }}
      >
        {financingMethods?.map((fm, index) => (
          <option key={index} value={fm.productType}>
            {fm.name}
          </option>
        ))}
      </TextField>
    </div>
  );
};

export default FinancingMethodSelector;
